<template>
	<section id="signature" class="section section--alt">
		<div class="container">
			<header v-reveal class="section__head">
				<p class="section__eyebrow">{{ t('signature.eyebrow') }}</p>
				<h2 class="section__title">{{ t('signature.title') }}</h2>
				<p class="section__subtitle">{{ t('signature.subtitle') }}</p>
			</header>

			<div class="signature__grid">
				<article
					v-for="(key, index) in SIGNATURE_KEYS"
					:key="key"
					v-reveal="(index % 2) * 80"
					class="signature__card"
				>
					<span class="signature__mark">
						<span class="marker">{{ t(`signature.items.${key}.mark`) }}</span>
					</span>
					<p class="signature__lead">{{ t(`signature.items.${key}.lead`) }}</p>
					<p class="signature__desc">{{ t(`signature.items.${key}.desc`) }}</p>
				</article>
			</div>
		</div>
	</section>
</template>

<script setup>
import { useI18n } from 'vue-i18n'
import { SIGNATURE_KEYS } from '@/helpers/constants'

defineOptions({ name: 'SignatureSection' })

const { t } = useI18n()
</script>

<style scoped lang="scss">
.signature__grid {
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(min(100%, 340px), 1fr));
	gap: clamp(20px, 2.6vw, 34px);

	@include below($bp-small) {
		grid-template-columns: 1fr;
	}
}

.signature__card {
	padding: clamp(24px, 2.6vw, 32px);
	background: $color-paper;
	border: 1px solid $color-line;
	border-radius: $radius;
	box-shadow: var(--shadow-sm);
	transition: transform 0.3s $ease, box-shadow 0.3s $ease;

	&:hover {
		transform: translateY(-4px);
		box-shadow: var(--shadow-md);
	}
}

.signature__mark {
	display: inline-block;
	font-size: clamp(1.02rem, 1.9vw, 1.24rem);
	font-weight: 800;
	color: $color-ink;
}

.signature__lead {
	margin-top: 16px;
	font-size: 1.06rem;
	font-weight: 700;
	color: $color-ink;
}

.signature__desc {
	margin-top: 8px;
	font-size: 0.96rem;
	color: $color-body;
}
</style>
